import api from "./api";
import { UsageSummary } from "../types";

export const usageService = {
  getSummary: async (): Promise<UsageSummary> => {
    const response = await api.get<{ success: boolean; data: UsageSummary }>(
      "/v1/usage/summary"
    );
    return response.data.data;
  },
};
